const ButtonLoader = () => {
  return (
    <div className="mfone-button-loader">
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};
export default ButtonLoader;
